<div class="input-tel">
  <span
    class="input-tel__icon"
    [class.input-tel__icon--error]="hasError"
    aria-hidden="true"
  >
    <svg
      class="input-tel__icon-svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 4.75H15.5C16.3284 4.75 17 5.42157 17 6.25V17.75C17 18.5784 16.3284 19.25 15.5 19.25H8.5C7.67157 19.25 7 18.5784 7 17.75V6.25C7 5.42157 7.67157 4.75 8.5 4.75Z"
        stroke="currentColor"
        stroke-width="1.8"
      />
      <path
        d="M10.25 7.25H13.75"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
      <circle
        cx="12"
        cy="16.25"
        r="0.9"
        fill="currentColor"
      />
    </svg>
  </span>

<input
  class="input-tel__field"
  [class.input-tel__field--error]="hasError"
  [id]="id"
  type="tel"
  [attr.maxlength]="usePhoneMask ? 15 : 11"
  inputmode="numeric"
  autocomplete="tel"
  [placeholder]="resolvedPlaceholder"
  [value]="displayValue"
  [disabled]="disabled"
  (input)="onInput($event)"
  (blur)="onBlurField()"
/>
</div>